import { render, staticRenderFns } from "./add-new-user.vue?vue&type=template&id=70b4b171&scoped=true&"
import script from "./add-new-user.vue?vue&type=script&lang=tsx&"
export * from "./add-new-user.vue?vue&type=script&lang=tsx&"
import style0 from "./add-new-user.vue?vue&type=style&index=0&id=70b4b171&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70b4b171",
  null
  
)

export default component.exports